import { useState } from "react";
import Header from "../../components/Header/Header";
import Home from "../Home/Home";
import Login from "../Login/Login";
import NoURL from "../NoURL/NoURL";
import { ILayoutProps } from "./interface";

const Layout = (props: ILayoutProps) => {
    const { urlCarryData } = props;
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
    const [headerFlag, setHeaderFlag] = useState<boolean>(false);
    // const [tokenDetails, setTokenDetails] = useState<any>(localStorage.getItem("tokenDetails") ? localStorage.getItem("tokenDetails") : sessionService.getDecryptedSession());

    return (
        <>
            {urlCarryData?.["currentSession"] && urlCarryData?.["hasURLDetails"] ?
                <>
                    <Header setIsMenuOpen={() => setIsMenuOpen(!isMenuOpen)} isMenuOpen={isMenuOpen} headerFlag={headerFlag} />
                    <Home />
                </>
                :
                <>
                    {urlCarryData?.["hasURLDetails"] ?
                        <Login />
                        :
                        <NoURL />
                    }
                    {/* <Login /> */}
                </>
            }
        </>
    )
}
export default Layout;